import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  Label,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  Tooltip,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  API_MEWS,
  gAPI_Ingetration,
  postAPI_Sync_Room,
} from '../../../../../../constants/APIs';
import Mews_Logo from '../../../../../../assets/mews_logo.jpg';
import Validation from '../../../../../../components/Validation';
let arr = [];
export default function MewsIntegration({
  visible,
  toggle,
  id,
  LoadIntegrations,
}) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [maskData, setMaskData] = useState({
    AccessToken: '',
    ClientToken: '',
  });
  const [titleToolTip, settitleToolTip] = useState(false);
  const [showRatesRadios, setRatesRadios] = useState(false);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    Client: '',
    ClientToken: '',
    AccessToken: '',
    ShowRates: false,
    ShowAvailability: false,
    ShowRatesAllRoom: false,
    ShowRatesSelectedRoom: false,
    EnterpriseId: '',
    RatePlanCode: '',
    ServiceId: '',
    ConfigurationId: '',
    IsBookingEngine: false,
    BookingEngineClient: '',
  });
  const toggleTitleToolTip = () => {
    settitleToolTip(!titleToolTip);
  };
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_MEWS}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setInputData({
            ...inputData,
            Name: res.data.name,
            Properties:
              res.data.properties !== null ? [res.data.properties[0]] : [],
            Client: res.data.channelDetails.client,
            ClientToken: res.data.channelDetails.clientToken,
            AccessToken: res.data.channelDetails.accessToken,
            ShowRates: res.data.channelDetails.showRates,
            ShowAvailability: res.data.channelDetails.showAvailability,
            ShowRatesAllRoom: res.data.channelDetails.showRatesAllRoom,
            ShowRatesSelectedRoom:
              res.data.channelDetails.showRatesSelectedRoom,
            EnterpriseId: res.data.channelDetails.enterpriseId,
            RatePlanCode: res.data.channelDetails.ratePlanCode,
            ConfigurationId: res.data.channelDetails.configurationId,
            IsBookingEngine: res.data.channelDetails.isBookingEngine,
            ServiceId: res.data.channelDetails.serviceId,
            BookingEngineClient: res.data.channelDetails.bookingEngineClient,
          });

          if (res.data.channelDetails.showRates === true) {
            setRatesRadios(true);
          }

          setMaskData({
            ...maskData,
            AccessToken: mask(res.data.channelDetails.accessToken),
            ClientToken: mask(res.data.channelDetails.clientToken),
          });
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);
  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleRateChange = (e) => {
    if (e.target.checked === true) {
      setRatesRadios(true);
      if (
        inputData.ShowRatesAllRoom === false &&
        inputData.ShowRatesSelectedRoom === false
      ) {
        setInputData({ ...inputData, ShowRatesAllRoom: e.target.checked });
      }
    } else {
      setRatesRadios(false);
    }
    setInputData({ ...inputData, ShowRates: e.target.checked });
  };

  const handleShowAllChange = (e) => {
    if (e.target.checked === true) {
      setInputData({
        ...inputData,
        ShowRatesAllRoom: e.target.checked,
        ShowRatesSelectedRoom: false,
      });
    } else {
      setInputData({ ...inputData, ShowRatesAllRoom: e.target.checked });
    }
  };

  const handleShowSelectedChange = (e) => {
    if (e.target.checked === true) {
      setInputData({
        ...inputData,
        ShowRatesSelectedRoom: e.target.checked,
        ShowRatesAllRoom: false,
      });
    } else {
      setInputData({ ...inputData, ShowRatesSelectedRoom: e.target.checked });
    }
  };

  const handleCheckBoxChange = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.checked });
  };

  const handleRatePlanChangeChange = (e) => {
    setInputData({ ...inputData, RatePlanCode: e.target.value });
  };

  const handleClientChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Client: e.target.value });
  };

  const handleClientTokenChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, ClientToken: mask(e.target.value) });
    setInputData({ ...inputData, ClientToken: e.target.value });
  };
  const handleChange = (e) => {
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };
  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setInputData({ ...inputData, Properties: [e.target.value] });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, Properties: [] });
    }
  };

  const handleSave = async () => {
    if (
      !inputData.Name.trim() ||
      !inputData.ClientToken.trim() ||
      !inputData.AccessToken.trim()
    ) {
      setMsg([
        "Integration Name is required.",
        "Client Token is required.",
        "Access Token is required.",
      ]);
      setOpen(true);
      return;
    }
    if (id !== undefined) {
      AxiosAPI({
        method: 'put',
        url: `${API_MEWS}/${id}?group_id=${getGroupID()}`,
        data: inputData,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    } else {
      AxiosAPI({
        method: 'post',
        url: API_MEWS,
        data: inputData,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    }
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? 'Add' : 'Update'} Integration</h6>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.Name}
                      required
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Client Id</Label>
                    <Input
                      type="text"
                      name="Client"
                      onChange={handleClientChange}
                      placeholder="Client Id"
                      defaultValue={inputData.Client}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Client Token</Label>
                    <Input
                      type="text"
                      name="ClientToken"
                      onChange={handleClientTokenChange}
                      placeholder="Client Token"
                      defaultValue={maskData.ClientToken}
                      required
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Access Token</Label>
                    <Input
                      type="text"
                      name="AccessToken"
                      onChange={handleChange}
                      placeholder="Access Token"
                      defaultValue={maskData.AccessToken}
                      required
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Enterprise Id</Label>
                    <Input
                      type="text"
                      name="EnterpriseId"
                      onChange={handleChange}
                      placeholder="Enterprise Id"
                      defaultValue={inputData.EnterpriseId}
                    />
                  </FormGroup>

                  <FormGroup className="mb-2">
                    <div className="">
                      <CustomInput
                        key="IsBookingEngine"
                        type="checkbox"
                        label="Enable Booking Engine"
                        name="IsBookingEngine"
                        checked={inputData.IsBookingEngine}
                        onChange={handleCheckBoxChange}
                      />
                    </div>
                  </FormGroup>
                  {inputData.IsBookingEngine === true && (
                    <Fragment>
                      <FormGroup className="mb-2">
                        <Label>Booking Engine Client</Label>
                        <Input
                          type="text"
                          name="BookingEngineClient"
                          onChange={handleChange}
                          placeholder="Booking Engine Client"
                          defaultValue={inputData.BookingEngineClient}
                        />
                      </FormGroup>
                      <FormGroup className="mb-2">
                        <Label>Configuration Id</Label>
                        <Input
                          type="text"
                          name="ConfigurationId"
                          onChange={handleChange}
                          placeholder="Configuration Id"
                          defaultValue={inputData.ConfigurationId}
                        />
                      </FormGroup>
                      <FormGroup className="mb-2">
                        <Label>Hotel Id</Label>
                        <Input
                          type="text"
                          name="ServiceId"
                          onChange={handleChange}
                          placeholder="Hotel Id"
                          defaultValue={inputData.ServiceId}
                        />
                      </FormGroup>
                      <FormGroup className="mb-2">
                        <div className="">
                          <CustomInput
                            key="ShowAvailability"
                            type="checkbox"
                            label="Show Availability Summary in Rooms View"
                            name="ShowAvailability"
                            checked={inputData.ShowAvailability}
                            onChange={handleCheckBoxChange}
                          />
                        </div>
                      </FormGroup>
                      <FormGroup className="mb-1">
                        <div className="">
                          <CustomInput
                            key="showRates"
                            type="checkbox"
                            label="Show Rates & Availability in Calendar"
                            name="showRates"
                            checked={inputData.ShowRates}
                            onChange={handleRateChange}
                          />
                        </div>
                      </FormGroup>
                      {showRatesRadios && (
                        <Fragment>
                          {' '}
                          <FormGroup className="mb-1 ml-5">
                            <div className="">
                              <CustomInput
                                key={'showallrooms'}
                                type="radio"
                                label={'Show Lowest Rate Among All Rooms'}
                                name="showRatesAllRoom"
                                checked={inputData.ShowRatesAllRoom}
                                onChange={handleShowAllChange}
                              />
                            </div>
                          </FormGroup>
                          <FormGroup className="mb-1 ml-5">
                            <div className="">
                              <CustomInput
                                key={'showselectedrooms'}
                                type="radio"
                                label={'Show Lowest Rate For The Selected Room'}
                                name="showRatesSelectedRoom"
                                checked={inputData.ShowRatesSelectedRoom}
                                onChange={handleShowSelectedChange}
                              />
                            </div>
                          </FormGroup>
                          <FormGroup className="mb-1">
                            <div className="">
                              <Label className="mt-3">
                                Use Specific Rate Plan To Fetch Rates{' '}
                                <i
                                  className="demo-icon simple-icon-info"
                                  id="titletip"
                                ></i>
                              </Label>
                              <Tooltip
                                placement="right"
                                isOpen={titleToolTip}
                                target="titletip"
                                toggle={toggleTitleToolTip}
                              >
                                Copy the rate plan from iHotelier to the field
                                below, this is usually the rate plan you have
                                specifically created for Myma.ai
                              </Tooltip>
                              <Input
                                type="text"
                                onChange={handleRatePlanChangeChange}
                                value={inputData.RatePlanCode}
                                name="RatePlanCode"
                                maxLength={50}
                                placeholder={'Rate Plan Code'}
                              />
                            </div>
                          </FormGroup>
                        </Fragment>
                      )}
                    </Fragment>
                  )}

                  <FormGroup className="mb-2">
                    <div className="integration-property">
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              p.id === inputData.Properties[0] ? true : false
                            }
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
